<template>
  <b-modal
    :id="id"
    size="sm"
    :title="'+ ' + label"
    :ok-title="trans('create')"
    :cancel-title="trans('cancel')"
    @show="onShow"
    @shown="$refs.input.focus()"
    @ok="onCreate"
  >
    <b-form-group :label="trans('name')">
      <b-form-input ref="input" v-model="name" autocomplete="0" :disabled="busy" @keydown="onKeydown" />
    </b-form-group>
    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  export default {
    props: {
      id: {
        type: String,
        default: 'create-tag-modal',
      },
      organization: Object,
      initialName: String,
      label: {
        type: String,
        default: 'tag',
      },
      type: String,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        name: this.initialName,
      }
    },
    computed: {
      serialized() {
        return {
          name: this.name,
          type: this.type == 'student' ? this.type : null,
        }
      }
    },
    methods: {
      onShow() {
        this.busy = false
        this.error = null
        this.name = this.initialName
      },
      onCreate(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/tags`
        axios.post(url, this.serialized)
        .then(response => {
          this.busy = false
          this.$emit('created', response.data)
          this.$bvModal.hide(this.id)
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onKeydown(e) {
        if (e.keyCode == 13) this.onCreate(e)
      },
    },
    mounted() {
      window.createTagModal = this
    },
  }
</script>